import { render, staticRenderFns } from "./ComandoVelocidadNuevo.vue?vue&type=template&id=6f64a654&"
import script from "./ComandoVelocidadNuevo.vue?vue&type=script&lang=ts&"
export * from "./ComandoVelocidadNuevo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6f64a654', component.options)
    } else {
      api.reload('6f64a654', component.options)
    }
    module.hot.accept("./ComandoVelocidadNuevo.vue?vue&type=template&id=6f64a654&", function () {
      api.rerender('6f64a654', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ComandoVelocidad/ComandoVelocidadNuevo.vue"
export default component.exports